import { render } from 'preact';
// Importing @hud/ui pulls in the design tokens and base stylesheet.
import { registerBuiltins } from '@hud/ui';
import { App } from './App.js';

// Must run before the first dashboard load — the engine validates widget
// configs against whatever is in the registry at that moment.
registerBuiltins();

const root = document.getElementById('app');
if (!root) throw new Error('Missing #app root element');

render(<App />, root);

// Only in production builds: a service worker in dev would serve stale modules
// and shadow Vite's HMR, which is a miserable way to lose an hour.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // BASE_URL, not a module-relative URL: sw.js is copied verbatim from
    // public/ to the deploy root, while import.meta.url points into /assets/.
    const base = import.meta.env.BASE_URL;
    navigator.serviceWorker
      .register(`${base}sw.js`, { scope: base })
      .catch((err: unknown) => console.warn('[hud] service worker registration failed', err));
  });
}
